import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { keys } from '@/api/queryKeys';
import { useLocationId } from '@/data/useLocationId';
import { settingsApi } from '../api/settingsApi';
import type { EmailIntegration } from '../api/types';

export function useEmailIntegration() {
  const locationId = useLocationId();
  return useQuery({
    queryKey: [...keys.settings.emailInteg, locationId ?? 0],
    queryFn: ({ signal }) => settingsApi.getEmailIntegration(locationId, { signal }),
    enabled: locationId != null,
    staleTime: 300_000,
  });
}

export function useUpdateEmailIntegration() {
  const queryClient = useQueryClient();
  const locationId = useLocationId();
  return useMutation({
    mutationFn: (data: Partial<EmailIntegration>) =>
      settingsApi.updateEmailIntegration(data, locationId),
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: keys.settings.emailInteg });
    },
  });
}
